import React, { useEffect, useState } from 'react';
import { ErrorText, FindLoad, useGlobalTextStyles } from 'utils';
import { SelectInput, ValidationInput } from '../inputs';
import { AddModalButton } from '../buttons';

export const EditDocumentNew = ({ docTypes, info, handleEdit, actionType, dontChangeType }) => {
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState('');
  const loading = FindLoad(actionType);
  const globalText = useGlobalTextStyles();
  const checkEdit = docTypes ? inputs?.type : true

  useEffect(() => {
    if (info) {
      const params = {
        ...info,
        type: info?.type,
        notes: info?.notes,
      };
      setInputs(params);
    }

  }, [info]);


  const handleChange = (e) => {
    setInputs(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
    if (error === e.target.name) setError('');
  };

  const handelEdit = () => {
    if (checkEdit) {
      handleEdit(inputs, 'edit');
    } else {
      setError(
        !inputs.type ? 'type' :
          '',
      );
    }
  };

  return (
    <div className='edit-document-new'>
      <p className={globalText.modalTitleWithMargin}>Edit Document</p>
      {docTypes &&
        <SelectInput
          style={inputs.type && 'edit-new-doc-notes-fill'}
          name={'type'}
          handleSelect={handleChange}
          value={inputs?.type}
          list={docTypes}
          label='Document Type*'
          type={'mc'}
          noHelper={false}
          showErrorAlways
          typeError={error === 'type' && ErrorText.field}
          disabled={dontChangeType}
        />
      }

      <ValidationInput
        className={`edit-new-doc-notes ${inputs?.note ? 'edit-new-doc-notes-fill' : ''}`}
        onChange={handleChange}
        variant={'outlined'}
        name={'notes'}
        label={'Notes'}
        type={'text'}
        multiline
        value={inputs?.notes}
        typeError={error === 'notes' && ErrorText.field}
      />

      <AddModalButton
        loading={!!loading}
        styles={{ width: '100%' }}
        handleClick={handelEdit}
        text={'Save'}
      />
    </div>
  );
};

